function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { FixedSizeList as List } from 'react-window';
import LogBookEntry from '../../model/LogBookEntry';
import Rider from '../../model/Rider';
import RiderResult from './RiderResult';
import './RiderResultsPanel.css';

var RiderResultsPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(RiderResultsPanel, _React$Component);

  function RiderResultsPanel(props) {
    var _this;

    _classCallCheck(this, RiderResultsPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RiderResultsPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "retrieveRiders", function () {
      var storage = _this.props.storage;
      Rider.all(storage).then(function (riders) {
        if (!_this._mounted) {
          return;
        }

        _this.setState({
          riders: riders
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;
      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height,
          storage = _this$props.storage;
      var riders = _this.state.riders;
      var rider = riders[index];

      var elementStyle = _extends({}, style);

      elementStyle.height = "".concat(425, "px");
      return React.createElement("div", {
        className: "rider-result-container",
        key: rider.id,
        style: elementStyle
      }, React.createElement(RiderResult, {
        width: width - 50,
        height: 425,
        rider: rider,
        storage: storage
      }));
    });

    _this.state = {
      riders: []
    };
    _this.listRef = React.createRef();
    return _this;
  }

  _createClass(RiderResultsPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      var activePanel = this.props.activePanel;
      var retrieveRiders = this.retrieveRiders;

      if (activePanel) {
        retrieveRiders();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var retrieveRiders = this.retrieveRiders;

      if (prevProps.activePanel !== this.props.activePanel && this.props.activePanel) {
        retrieveRiders();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderItem = this.renderItem;
      var _this$props2 = this.props,
          app = _this$props2.app,
          width = _this$props2.width,
          height = _this$props2.height,
          storage = _this$props2.storage;
      var riders = this.state.riders;
      var tabWidth = window.cordova ? innerWidth / 5 : innerWidth / 4;
      var tabOffset = window.cordova ? 3 : 2;

      if (!this.props.activePanel) {
        return null;
      }

      return React.createElement("div", {
        className: "rider-results-panel",
        style: {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        }
      }, riders.length === 0 && React.createElement("div", {
        className: "start-here"
      }, React.createElement("div", {
        className: "caption"
      }, "these are your race results"), React.createElement("div", {
        className: "caption"
      }, "tap here to start logging!"), React.createElement("div", {
        className: "pointer",
        style: {
          marginLeft: "".concat(tabOffset * tabWidth, "px"),
          width: "".concat(tabWidth, "px")
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faHandPointRight
      }))), riders.length > 0 && React.createElement("div", {
        className: "rider-results-count"
      }, "".concat(riders.length, " ").concat(riders.length > 1 ? 'riders' : 'rider')), riders.length > 0 && React.createElement(List, {
        ref: this.listRef,
        className: "rider-results",
        height: height - 35,
        itemCount: riders.length,
        itemSize: 435,
        layout: "vertical",
        width: width
      }, renderItem));
    }
  }]);

  return RiderResultsPanel;
}(React.Component);

export default RiderResultsPanel;